@if (!onlyOne) {
  <button
    type="button"
    mat-icon-button
    [ngClass]="cssClass"
    [matTooltip]="tooltip"
    [disabled]="loading || disabled"
    [matMenuTriggerFor]="exportMenu">
    @if (!loading) {
      <mat-icon>file_download</mat-icon>
    }
    @if (loading) {
      <mat-spinner class="button-spinner"></mat-spinner>
    }
  </button>
}
<mat-menu #exportMenu="matMenu" class="small-menu">
  @if (!exludeType.xls) {
    <button mat-menu-item (click)="doExport('XLS')">
      <span>Excel</span>
    </button>
  }
  @if (!exludeType.pdf) {
    <button mat-menu-item (click)="doExport('PDF')">
      <span>PDF</span>
    </button>
  }
  @if (!exludeType.csv) {
    <button mat-menu-item (click)="doExport('CSV')">
      <span>CSV</span>
    </button>
  }
  @if (!exludeType.json) {
    <button mat-menu-item (click)="doExport('JSON')">
      <span>JSON</span>
    </button>
  }
  @if (!exludeType.xml) {
    <button mat-menu-item (click)="doExport('XML')">
      <span>XML</span>
    </button>
  }
  @if (!exludeType.svg) {
    <button mat-menu-item (click)="doExport('SVG')">
      <span>SVG</span>
    </button>
  }
  @if (!exludeType.png) {
    <button mat-menu-item (click)="doExport('PNG')">
      <span>PNG</span>
    </button>
  }
  @for (extra of extraButtons; track extra) {
    <button
      mat-menu-item
      (click)="doExport(extra)">
      <span>{{ extra }}</span>
    </button>
  }
</mat-menu>

@if (onlyOne) {
  <button
    type="button"
    color="primary"
    mat-icon-button
    [ngClass]="cssClass"
    [matTooltip]="tooltip"
    [disabled]="loading || disabled"
    (click)="doExport(show)">
    @if (!loading) {
      <mat-icon>get_app</mat-icon>
    }
    @if (loading) {
      <mat-spinner class="button-spinner"></mat-spinner>
    }
  </button>
}
